import React from 'react';
import cn from 'classnames';

import css from './ScheduleButton.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  bgType?: 'regular' | 'blur';
  shapeType?: 'regular' | 'round';
}

const SCHEDULE = 'Schedule';
const MEETING = '1:1 meeting';

const ScheduleButton = (props: Props) => {
  const { className = '', onClick, bgType = 'regular', shapeType = 'regular' } = props;

  return (
    <button
      className={cn(css.scheduleBtn, css[`bg-${bgType}`], css[`shape-${shapeType}`], className)}
      type="button"
      onClick={onClick}
    >
      <div className={css.btnInner}>
        <p>{SCHEDULE}</p>
        <p>{MEETING}</p>
      </div>
    </button>
  );
};

export default ScheduleButton;
